// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { useCallback, useEffect, useRef, useState } from "react";

export const useScrollDirection = () => {
    const [visible, setVisible] = useState(true);
    const isManual = useRef(false);
    const lastY = useRef(0);
    const ignoreUntil = useRef(0);

    const toggle = useCallback(() => {
        setVisible(prev => {
            const next = !prev;
            isManual.current = next;
            ignoreUntil.current = Date.now() + 400;
            return next;
        });
    }, []);

    useEffect(() => {
        lastY.current = window.scrollY;

        const onScroll = () => {
            if (Date.now() < ignoreUntil.current) return;

            const currentY = window.scrollY;
            const diff = currentY - lastY.current;
            lastY.current = currentY;

            if (currentY < 50) {
                isManual.current = false;
                setVisible(true);
                return;
            }

            if (isManual.current) {
                return;
            }

            if (diff > 5) {
                setVisible(false);
            }
        };

        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return { visible, toggle };
};

export default useScrollDirection;
